import { render, staticRenderFns } from "./TDSModal.vue?vue&type=template&id=79367233&scoped=true&"
import script from "./TDSModal.ts?vue&type=script&lang=ts&"
export * from "./TDSModal.ts?vue&type=script&lang=ts&"
import style0 from "./TDSModal.scss?vue&type=style&index=0&id=79367233&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79367233",
  null
  
)

export default component.exports